import { mountSharedBrandEntry } from "@dashboard/brands/mountBrandEntry";

mountSharedBrandEntry("avaya");
